<template>
  <iframe
    id="myframe"
    style="display: block"
    name="myframe"
    width="100%"
    height="100%"
    frameborder="0"
  ></iframe>
</template>
<style>
html,
body {
  height: 100%;
}
</style>
<script>
import {
  getAppStorage,
  callPhone,
  isLoginIOSAnd,
  callWebview,
} from "../../service/bridge";
export default {
  components: {},
  directives: {},
  data() {
    return {
      env: "prod",
      thinkiveUrl:
        "https://test-zh-new.wkzq.com.cn:8091/m/ismp/views/login/index.html?ext_channel=wkthshzapp",
      url: {
        dev: {
          newsUrl: "https://wx.wkzq.com.cn/wkzqnews/quickmsg",
          yht:
            "https://test-zh-new.wkzq.com.cn:8091/web/yht/mobile/html/allPositions.html?channel=ths",
          yhtqy:
            "https://test-zh-new.wkzq.com.cn:8091/web/yht/mobile/html/yhtSigning.html?channel=ths",
          yhtmmxg:
            "https://test-zh-new.wkzq.com.cn:8091/web/yht/mobile/html/yhtPwdModify.html?channel=ths",
          yhtzlxg:
            "https://test-zh-new.wkzq.com.cn:8091/web/yht/mobile/html/yhtModifyInfo.html?channel=ths",
          rqqy:
            "https://test-zh-new.wkzq.com.cn:8091/web/yht/mobile/html/smt_qymdcx.html?channel=ths",
          ywblindex:
            "https://test-zh-new.wkzq.com.cn:8091/m/ismp/views/login/index.html?ext_channel=wkthshzapp", //本地开发
          ywblzhzh:
            "https://test-zh-new.wkzq.com.cn:8091/m/ismp/views/retrieveAccounts/authentication.html?ext_channel=wkthshzapp", //找回密码
          ywbljg:
            "https://test-zh-new.wkzq.com.cn:8091/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=jg", //加挂股东户
          ywbljjkh:
            "https://test-zh-new.wkzq.com.cn:8091/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=jjkh", //开放式基金开户
          ywblzdjy:
            "https://test-zh-new.wkzq.com.cn:8091/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=zdjy", //指定交易
          ywblggtlist:
            "https://test-zh-new.wkzq.com.cn:8091/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=ggt", //港股通(深、沪)
          ywblcyb:
            "https://test-zh-new.wkzq.com.cn:8091/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=cybopen", //创业板权限开通(新开、补签、转签)
          ywblcybxy:
            "https://test-zh-new.wkzq.com.cn:8091/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=cybXy", //信用创业板权限开通(新开、补签)
          ywblfxjs:
            "https://test-zh-new.wkzq.com.cn:8091/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=fxjs", //风险警示板
          ywbltsgpzl:
            "https://test-zh-new.wkzq.com.cn:8091/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=tsgpzl", //退市股票权限
          ywblkcb:
            "https://test-zh-new.wkzq.com.cn:8091/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=kcb", //科创板开通
          ywblgpjy:
            "https://test-zh-new.wkzq.com.cn:8091/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=gpjy", //挂牌业务权限开通
          ywblxgzjm:
            "https://test-zh-new.wkzq.com.cn:8091/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=modifyFundPwd", //修改资金密码
          ywblxgjym:
            "https://test-zh-new.wkzq.com.cn:8091/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=modifyTradePwd", //修改交易密码
          ywblzlbg:
            "https://test-zh-new.wkzq.com.cn:8091/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=grzlbg", //普通资料变更
          ywblczsj:
            "https://test-zh-new.wkzq.com.cn:8091/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=modifiedmobile", //重置手机号码
          ywblfxcp:
            "https://test-zh-new.wkzq.com.cn:8091/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=fxcp", //风险测评
        },
        prod: {
          newsUrl: "https://wx.wkzq.com.cn/wkzqnews/quickmsg",
          yht:
            "https://wx.wkzq.com.cn/web/yht/mobile/html/allPositions.html?channel=ths",
          yhtqy:
            "https://wx.wkzq.com.cn/web/yht/mobile/html/yhtSigning.html?channel=ths",
          yhtmmxg:
            "https://wx.wkzq.com.cn/web/yht/mobile/html/yhtPwdModify.html?channel=ths",
          yhtzlxg:
            "https://wx.wkzq.com.cn/web/yht/mobile/html/yhtModifyInfo.html?channel=ths",
          rqqy:
            "https://wx.wkzq.com.cn/web/yht/mobile/html/smt_qymdcx.html?channel=ths",
          ywblindex:
            "https://zh-new.wkzq.com.cn:8701/m/ismp/views/login/index.html?ext_channel=wkthshzapp", //本地开发
          ywblzhzh:
            "https://zh-new.wkzq.com.cn:8701/m/ismp/views/retrieveAccounts/authentication.html?ext_channel=wkthshzapp", //找回密码
          ywbljg:
            "https://zh-new.wkzq.com.cn:8701/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=jg", //加挂股东户
          ywbljjkh:
            "https://zh-new.wkzq.com.cn:8701/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=jjkh", //开放式基金开户
          ywblzdjy:
            "https://zh-new.wkzq.com.cn:8701/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=zdjy", //指定交易
          ywblggtlist:
            "https://zh-new.wkzq.com.cn:8701/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=ggt", //港股通(深、沪)
          ywblcyb:
            "https://zh-new.wkzq.com.cn:8701/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=cybopen", //创业板权限开通(新开、补签、转签)
          ywblcybxy:
            "https://zh-new.wkzq.com.cn:8701/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=cybXy", //信用创业板权限开通(新开、补签)
          ywblfxjs:
            "https://zh-new.wkzq.com.cn:8701/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=fxjs", //风险警示板
          ywbltsgpzl:
            "https://zh-new.wkzq.com.cn:8701/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=tsgpzl", //退市股票权限
          ywblkcb:
            "https://zh-new.wkzq.com.cn:8701/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=kcb", //科创板开通
          ywblgpjy:
            "https://zh-new.wkzq.com.cn:8701/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=gpjy", //挂牌业务权限开通
          ywblxgzjm:
            "https://zh-new.wkzq.com.cn:8701/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=modifyFundPwd", //修改资金密码
          ywblxgjym:
            "https://zh-new.wkzq.com.cn:8701/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=modifyTradePwd", //修改交易密码
          ywblzlbg:
            "https://zh-new.wkzq.com.cn:8701/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=grzlbg", //普通资料变更
          ywblczsj:
            "https://zh-new.wkzq.com.cn:8701/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=modifiedmobile", //重置手机号码
          ywblfxcp:
            "https://zh-new.wkzq.com.cn:8701/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=fxcp", //风险测评
          ywblkzhgszq:
            "https://zh-new.wkzq.com.cn:8701/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=kzhgszq", //可转换公司债券
          ywblkzhgszqXy:
            "https://zh-new.wkzq.com.cn:8701/m/ismp/views/login/index.html?ext_channel=wkthshzapp&module_name=kzhgszqXy", //可转换公司债券(信用)
        },
      },
    };
  },
  computed: {},
  activated() {},
  mounted() {
    var type = this.$route.params.type;
    // if (type == "rqqy") {
    //   alert("该功能即将上线，敬请期待。");
    //   return;
    // }
    document.getElementById("myframe").src = this.url[this.env][type];

    window.addEventListener(
      "message",
      function (event) {
        if (event.data && event.data != "") {
          if (event.data.indexOf("getYhtInfo") == 0) {
            // var res={"login_type":"Y","login_no":"990000093986","cust_name":"黄小妮","user_ticket":"ZjaNEgvYdKbGD+eGDJra6bLqNiY18pKT4yih9wGPIMA=#lKDcA/Pzx3egbjSG5xi6wsbBCznrBEMaQs7osATiWEKocgh/nNsPcMulLZPWPyIYfZkr8LjqC8qpzlfglpLjGwamIPMKVUhKnGZJs7kI0nyuvG8rzXbeWrwr0h+uII52mkllOKiaYWGyvDOma6GvlA==#1#s7Z868HmW0k=#","ticket_no":"12545050","channel":"TFX","terminal_info":""}
            //  var res={}
            //  document.getElementById("myframe").contentWindow.postMessage("yhtInfo|"+JSON.stringify(res),"*");

            //获取一户通所需信息
            getAppStorage(function (data) {
              try {
                if (data.err_code == "0") {
                  console.log("yhtInfo|" + JSON.stringify(data.data));
                  // alert()
                  document
                    .getElementById("myframe")
                    .contentWindow.postMessage(
                      "yhtInfo|" + JSON.stringify(data.data),
                      "*"
                    );
                }
              } catch (e) {}
            }, "yhtInfo");
          } else if (event.data.indexOf("stockSkip") == 0) {
            //股票代码跳转
            var param = event.data.split("|");
            if (param.length > 3) {
              console.log(
                "client://hxsecurity.frame.router/market_stock_details?stockcode=" +
                  param[1] +
                  "&stockname=" +
                  param[2] +
                  "&stockmarket=" +
                  param[3]
              );
              window.location.href =
                "client://hxsecurity.frame.router/market_stock_details?stockcode=" +
                param[1] +
                "&stockname=" +
                param[2] +
                "&stockmarket=" +
                param[3] +
                "";
            }
          } else if (event.data.indexOf("backApp") == 0) {
            //返回到APP页面
            history.back();
          } else if (event.data.indexOf("rzrqSell") == 0) {
            //跳转融券卖出页面
            var tzurl = "client://hxsecurity.frame.router/jiaoyi_rzrq?1=1";
            var paramUrl = "";
            var param = event.data.split("|");
            if (param.length > 3) {
              paramUrl =
                "&stockcode=" +
                param[1] +
                "&stockname=" +
                param[2] +
                "&stockmarket=" +
                param[3];
            }
            var multiple = "0";
            if (param.length > 4) {
              multiple = param[4];
            }
            console.log(
              tzurl + paramUrl + "&rzrq_multiple_index=0#jiaoyi_rzrq_sell"
            );
            window.location.href =
              tzurl +
              paramUrl +
              "&rzrq_multiple_index=" +
              multiple +
              "#jiaoyi_rzrq_sell";
          } else if (event.data.indexOf("rzrqBuy") == 0) {
            //跳转融资买入页面
            console.log(
              "client://hxsecurity.frame.router/jiaoyi_rzrq?rzrq_multiple_index=0#jiaoyi_rzrq_buy"
            );
            window.location.href =
              "client://hxsecurity.frame.router/jiaoyi_rzrq?rzrq_multiple_index=0#jiaoyi_rzrq_buy";
          } else if (event.data.indexOf("rzrqYhzz") == 0) {
            //跳转两融转账页面
            window.location.href =
              "client://hxsecurity.frame.router/jiaoyi_rzrq_yhzzq";
          } else if (event.data.indexOf("jjrg") == 0) {
            //跳转基金认购页面
            window.location.href =
              "client://hxsecurity.frame.router/jiaoyi_openfund_jjrg";
          } else if (event.data.indexOf("jjsg") == 0) {
            //跳转基金申购页面
            window.location.href =
              "client://hxsecurity.frame.router/jiaoyi_openfund_jjsg";
          } else if (event.data.indexOf("jjsh") == 0) {
            //跳转基金赎回页面
            window.location.href =
              "client://hxsecurity.frame.router/jiaoyi_openfund_jjsh";
          } else if (event.data.indexOf("jyBuy") == 0) {
            //跳转交易买入页面
            console.log(
              "client://hxsecurity.frame.router/jiaoyi_weituo?rp_flag_force_use_current_stack=true#jiaoyi_buy"
            );
            window.location.href =
              "client://hxsecurity.frame.router/jiaoyi_weituo?rp_flag_force_use_current_stack=true#jiaoyi_buy";
          } else if (event.data.indexOf("jySell") == 0) {
            //跳转交易卖出页面
            console.log(
              "client://hxsecurity.frame.router/jiaoyi_weituo?rp_flag_force_use_current_stack=true#jiaoyi_sell"
            );
            window.location.href =
              "client://hxsecurity.frame.router/jiaoyi_weituo?rp_flag_force_use_current_stack=true#jiaoyi_sell";
          } else if (event.data.indexOf("ptYhzz") == 0) {
            //跳转普通银行转账页面
            window.location.href =
              "client://hxsecurity.frame.router/jiaoyi_yzzz_yhzzq";
          } else if (event.data.indexOf("isLoginIOSAnd") == 0) {
            //跳转到登陆页面
            console.log("开始调用isLoginIOSAnd:==========");
            isLoginIOSAnd(function (resp) {
              console.log(resp);
            });
          } else if (event.data.indexOf("goBackAction") == 0) {
            //关闭H5
            console.log("开始调用gobackAction:==========");
            callWebview("goback", { type: "component" });
          } else if (event.data.indexOf("sdkSkip") == 0) {
            console.log("开始调用sdkSkip:==========" + event.data);
            //跳转到SDK的url
            var param = event.data.split("|");
            if (param.length > 1) {
              var skipUrl = param[1];
              window.location.href =
                "client://hxsecurity.frame.router/wangting_sdk?url=" +
                encodeURIComponent(skipUrl);
            }
          }
        }
      },
      false
    );
  },
  updated() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang="less">
@import "./style/index.less";
</style>
<style></style>
